// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Cye_","title":"Info_title__1NNN1","links":"Info_links__2VFMl","link":"Info_link__1abRH","logo":"Info_logo__1DASJ"};